import script from "./ProductsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProductsDetail.vue?vue&type=style&index=0&id=1c9c4813&lang=css"

const __exports__ = script;

export default __exports__